import { apiClient as api } from "./httpClient";

// Plano de contas da DRE: versões imutáveis do conjunto de categorias/subcategorias
// que entram na DRE. Editar cria versão nova; a vigente é a ativa de maior número.

export interface DreConfigurationSummary {
  id: string;
  entityId: string;
  version: number;
  notes?: string;
  active: boolean;
  createdAt: string;
  createdByName?: string;
  itemCount: number;
}

export interface DreConfigurationItem {
  accountTypeExternalId: string;
  typeName: string;
  parentName?: string;
}

export interface DreConfigurationDetail {
  id: string;
  entityId: string;
  version: number;
  notes?: string;
  active: boolean;
  createdAt: string;
  items: DreConfigurationItem[];
}

export interface ChartSubCategory {
  externalId: string;
  name: string;
}

export interface ChartCategory {
  externalId: string;
  name: string;
  subCategories: ChartSubCategory[];
}

export interface ChartRoot {
  name: string;
  categories: ChartCategory[];
}

export interface CreateDreConfigurationPayload {
  entityId: string;
  notes?: string;
  selectedExternalIds: string[];
}

export const dreConfigurationService = {
  getChartOfAccounts: async (entityId: string): Promise<ChartRoot[]> => {
    const r = await api.get("/dre-configurations/chart-of-accounts", { params: { entityId } });
    return Array.isArray(r.data) ? r.data : [];
  },

  getByEntity: async (entityId: string): Promise<DreConfigurationSummary[]> => {
    const r = await api.get(`/dre-configurations/by-entity/${entityId}`);
    return Array.isArray(r.data) ? r.data : [];
  },

  getById: async (id: string): Promise<DreConfigurationDetail> => {
    const r = await api.get(`/dre-configurations/${id}`);
    return r.data;
  },

  create: async (payload: CreateDreConfigurationPayload): Promise<void> => {
    await api.post("/dre-configurations", payload);
  },

  setActive: async (id: string, active: boolean): Promise<void> => {
    await api.patch(`/dre-configurations/${id}/active`, { active });
  },
};
